module.exports = __webpack_public_path__ + "static/img/2-1.81e41bea.png";